import { API } from '../api'
import * as types from './mutation-types'

export default {
    [types.IMPORT_SUBMIT_IMPORT](state, importParams) {
        API.importSqg(importParams.params, importParams.sucCallBack, importParams.failCallBack);
    }
}

